export const DocGenProduct = 'Document Template - Usage tracking';
export type EventMetadata = object;

export const DocumentTemplateCreateTrackEvent = 'Document Template Created';
export const DocumentTemplateEditTrackEvent = 'Document Template Edited';
export const SignatureRequestCreatedFromDocumentTemplateTrackEvent =
	'Signature Request Created From Document Template';
export const SignatureRequestSystemFilledFieldUpdatedTrackEvent =
	'Signature Request System Filled Field Updated';

const DOCGEN_FOOTER_ANALYTICS_PREFIX = 'DocgenFooter';
const DOCGEN_SEND_SIGNATURE_REQUEST_ANALYTICS_PREFIX = 'DocgenSendSignatureRequest';

// Footer Next Button AnalyticsId
export const FooterNextButtonAnalyticsIds = {
	StartPage: `${DOCGEN_FOOTER_ANALYTICS_PREFIX}-NextButton-StartPage`,
	PreparePage: `${DOCGEN_FOOTER_ANALYTICS_PREFIX}-NextButton-PreparePage`,
	ReviewPageSaveTemplate: `${DOCGEN_FOOTER_ANALYTICS_PREFIX}-SaveTemplate-ReviewPage`,
};

// Footer Previous Button AnalyticsId
export const FooterPreviousButtonAnalyticsIds = {
	PreparePage: `${DOCGEN_FOOTER_ANALYTICS_PREFIX}-PreviousButton-PreparePage`,
	ReviewPage: `${DOCGEN_FOOTER_ANALYTICS_PREFIX}-PreviousButton-ReviewPage`,
};

// Send Signature Request Footer Button AnalyticsId
export const SendSignatureRequestFooterAnalyticsIds = {
	NextStepSelectRecipients: `${DOCGEN_SEND_SIGNATURE_REQUEST_ANALYTICS_PREFIX}-NextButton-AddRecipientsPage`,
	NextStepReviewAndSend: `${DOCGEN_SEND_SIGNATURE_REQUEST_ANALYTICS_PREFIX}-NextButton-ReviewPage`,
	PreviousStepSelectRecipients: `${DOCGEN_SEND_SIGNATURE_REQUEST_ANALYTICS_PREFIX}-PreviousButton-AddRecipientsPage`,
	Customize: `${DOCGEN_SEND_SIGNATURE_REQUEST_ANALYTICS_PREFIX}-CustomizeButton`,
	SendSignatureRequest: `${DOCGEN_SEND_SIGNATURE_REQUEST_ANALYTICS_PREFIX}-SendSignatureRequestButton-ReviewPage`,
	StartOver: `${DOCGEN_SEND_SIGNATURE_REQUEST_ANALYTICS_PREFIX}-StartOverButton`,
	ChangeTemplate: `${DOCGEN_SEND_SIGNATURE_REQUEST_ANALYTICS_PREFIX}-ChangeTemplateButton`,
};
